export function formatNumber(num, isFa = false) {
  num = Math.round(num * 1);
  num = num + '';
  return isFa
    ? num.toLocaleString('ar-EG')
    : num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
export default formatNumber;
